// Module
var code = `<div id="pac" class="mt-1 border-b border-gray-300"></div> `;
// Exports
export default code;